"use client";
import dynamic from "next/dynamic";
import React from "react";
const AnimatedTimeline = dynamic(() => import("@/Components/AnimatedTimeline"),{ssr: true});

type TimelineItem = {
  id: number;
  title: string;
  description: string;
};

interface AccordionProps {
  steps?: TimelineItem[];
}

const Timeline: React.FC<AccordionProps> = ({ steps }) => {
  return (
    <div className="relative w-full mx-auto mt-[40px]">
      {/* Timeline Items */}
      <div className="flex flex-col gap-[40px]">
        <AnimatedTimeline
          items={steps ?? []}
          activationOffset={0}
          reverseLayout={false}
        />
      </div>
    </div>
  );
};

export default Timeline;
